<template>
    <Tree :data="tree" show-checkbox :check-strictly="true" :render="renderTree" @on-check-change="onCheckChange" class="form-item-container" style="max-height: 550px"></Tree>
</template>

<script>
    export default {
        name: "depart-checker",
        props: {
            departTree: Array
        },
        data () {
            return {
                tree: []
            }
        },
        watch: {
            departTree (newV, oldV) {
                this.tree = JSON.parse(JSON.stringify(newV));
            }
        },
        methods: {
            renderTree (h, { root, node, data }) {
                return h('span',[h('Icon', {
                    props: {
                        type: data.type?'md-contacts':'ios-briefcase'
                    },
                    style: {
                        marginRight: '8px'
                    }
                }),  data.name])
            },
            onCheckChange (checkedArr) {
                this.$emit('on-select', checkedArr.map(depart => {
                    return depart.id
                }))
            }
        }
    }
</script>

<style scoped>

</style>